/* eslint-disable no-shadow */
import React, { useState, useEffect, useRef } from 'react'
import classNames from 'classnames'
import { message } from 'antd'
import { cloneDeep } from 'lodash'
import { teamHasAuth } from 'meinian-package/src/utils/auth'
import request from 'meinian-package/src/utils/request'
import ModalConfirm from 'meinian-package/src/component/modal/modalConfirm'
import Input from 'meinian-package/src/baseComponent/input'
import Icon from 'meinian-package/src/component/icon'
import Dropdown from 'meinian-package/src//baseComponent/dropdown'
import { uuid } from 'meinian-package/src/utils'
import DragList from 'baseComponent/dragList'
import styles from './index.module.less'

const defaultProcess = [
  {
    id: -1,
    lastChooseTime: '',
    processName: '示例流程1',
    steps: [
      {
        id: 0,
        processId: 0,
        sortValue: 1,
        stepName: '样衣打版',
        teamId: 0,
        userId: 0
      },
      {
        id: 0,
        processId: 0,
        sortValue: 2,
        stepName: '样衣打样',
        teamId: 0,
        userId: 0
      },
      {
        id: 0,
        processId: 0,
        sortValue: 3,
        stepName: '样衣入库',
        teamId: 0,
        userId: 0
      }
    ],
    teamId: 0,
    userId: 0
  },
  {
    id: -2,
    lastChooseTime: '',
    processName: '示例流程2',
    steps: [
      {
        id: 0,
        processId: 0,
        sortValue: 1,
        stepName: '样衣采买',
        teamId: 0,
        userId: 0
      },
      {
        id: 0,
        processId: 0,
        sortValue: 2,
        stepName: '样衣入库',
        teamId: 0,
        userId: 0
      }
    ],
    teamId: 0,
    userId: 0
  }
]

const STEPS = [
  { label: '采买样衣', value: '采买样衣' },
  { label: '样衣打版', value: '样衣打版' },
  { label: '样衣打样', value: '样衣打样' },
]

/**
 * @description: 流程自定义
 * @return {*}
 */
export default ({ authAdmin }) => {
  const [process, setProcess] = useState([])
  const $scroll = useRef(null)

  useEffect(() => {
    fetchSampleData()
  }, [])

  const fetchSampleData = () => {
    request.get('/zhikuan/ins/inspiration/work/platform/get-sample-process').then(res => {
      const _data = res.length ? res : cloneDeep(defaultProcess)
      _data.forEach((itemWarp) => {
        itemWarp.steps.forEach(item => {
          item.tempId = uuid()
        })
      })
      setProcess(_data)
    })
  }

  const onOk = (processIndex, item) => {
    const isRepeat = process.find((it, i) => i !== processIndex && it.processName === item.processName)
    if (isRepeat) {
      message.warn('流程标题不能重复')
      return
    }
    setProcess(pre => pre.map((i, index) => {
      if (index === processIndex) {
        i.steps = i.steps.filter(_item => _item.stepName && _item.stepName?.trim())
        i.steps.forEach((_item, k) => {
          _item.sortValue = k + 1
        })
        return {
          ...i,
          editStatus: false
        }
      }
      return i
    }))
    const _item = cloneDeep(item)
    if (_item.id === -1 || _item.id === -2) {
      _item.id = null
    }
    const _steps = _item.steps.filter(__item => __item.stepName && __item.stepName?.trim())
    _item.steps = cloneDeep(_steps)
    request.post('/zhikuan/ins/inspiration/work/platform/save-or-update-process', _item)
  }

  const onIsOperationProcess = async (id) => {
    const res = await request.get('/zhikuan/ins/inspiration/work/platform/is-allow-update', { params: { id } })
    return res
  }

  const onDelete = async (processIndex, item) => {
    const success = await onIsOperationProcess(item.id)
    if (success) {
      item.id !== -1 && item.id !== -2 ? ModalConfirm.show({
        title: '删除流程',
        content: '是否确定删除该流程',
        onOk: async () => {
          request.get('/zhikuan/ins/inspiration/work/platform/delete-sample-process', { params: { id: item.id } }).then(_success => {
            if (_success) {
              setProcess(pre => pre.filter((_, index) => index !== processIndex))
            }
          })
        }
      })
        : setProcess(pre => pre.filter((_, index) => index !== processIndex))
    } else {
      message.error('该流程已经被关联，无法删除')
    }
  }

  const onAdd = () => {
    if (process?.length >= 9) return message.warning('最多设置9个流程')
    const newProcess = {
      processName: `新建流程${process.length + 1}`,
      editStatus: true,
      steps: [
        { stepName: '样衣打版', sortValue: 1, id: null, tempId: uuid() },
        { stepName: '样衣打样', sortValue: 2, id: null, tempId: uuid() },
        { stepName: '样衣入库', sortValue: 2, id: null, tempId: uuid() },
      ]
    }
    request.post('/zhikuan/ins/inspiration/work/platform/save-or-update-process', newProcess).then(res => {
      newProcess.id = res
      process.push(newProcess)
      setProcess(pre => pre.map((item, index) => {
        if (index == pre.length - 1) {
          return {
            ...item,
            editStatus: true
          }
        }
        return {
          ...item,
          editStatus: false
        }
      }))
      $scroll?.current?.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'end' })
    })
  }

  const onAddStep = (processId) => {
    const currentProcess = process.find((item) => item.id == processId)
    const lastItem = currentProcess.steps.pop()
    currentProcess.steps.push({ tempId: uuid(), processId: currentProcess.id, stepName: '', sortValue: currentProcess.steps.length + 2 })
    currentProcess.steps.push(lastItem)
    setProcess(pre => [...pre])
  }

  const onDeleteStep = (processId, stepTempId) => {
    process.forEach(item => {
      if (item.id === processId) {
        const _index = item.steps.findIndex(i => i.tempId === stepTempId)
        item.steps.splice(_index, 1)
      }
    })
    setProcess(pre => [...pre])
  }

  const stepChange = (step, processId, stepTempId) => {
    process.forEach(item => {
      if (item.id === processId) {
        item.steps.forEach(_step => {
          if (_step.tempId === stepTempId) {
            _step.stepName = step
          }
        })
      }
    })
    setProcess(pre => [...pre])
  }

  const onChangeName = (name, processIndex) => {
    setProcess(pre => {
      pre.forEach((item, index) => {
        if (index == processIndex) {
          item.processName = name
        }
      })
      return [...pre]
    })
  }

  const onEdit = async (idx, module) => {
    const isOperation = await onIsOperationProcess(module.id)
    if (isOperation) {
      setProcess(pre => pre.map((i, index) => {
        if (index === idx) {
          return {
            ...i,
            editStatus: true
          }
        }
        return i
      }))
    } else {
      message.error('该流程已经被关联，无法编辑')
    }
  }

  const onSort = (newIndex, oldIndex, processId) => {
    process.forEach(item => {
      if (item.id === processId) {
        const temp = cloneDeep(item.steps[oldIndex])
        item.steps.splice(oldIndex, 1)
        item.steps.splice(newIndex, 0, temp)
      }
    })
    setProcess(pre => [...pre])
  }

  return <div className={styles['process-container']}>
    <div className="process-header-title">
      样衣流程设置
    </div>
    {
        teamHasAuth('meinian_sample_process') && <div className="sample-process">
          <div className="process-header">
            {
            !authAdmin && <div className="add-process-btn" onClick={() => onAdd()}>
              <Icon type="m-tianjia_miaobian" />
              <span>新增流程</span>
            </div>
          }
          </div>
          <div className="process-content">
            <div ref={$scroll}>
              {process.map((module, idx) => {
                return <div className="process-item" key={idx}>
                  <div className="process-item-header">
                    <div className="item-title">
                      {
                    module?.editStatus
                      ? <Input
                          wrapClassName="process-item-header-wrap-input"
                          maxlength={10}
                          value={module.processName}
                          onChange={(e) => onChangeName(e?.target?.value, idx)}
                          wrapStyle={{ width: 240, height: 32 }}
                          suffix={<div className="process-item-header-wrap-input-num">{module.processName.length}/10</div>}
                      />
                      : <span>{module.processName}</span>
                  }
                    </div>
                    {
                  !authAdmin && <div className="item-operation-btn">
                    {
                    module?.editStatus
                      ? <div
                          className="text-btn"
                          onClick={() => onOk(idx, module)}
                      >
                        <span className="btn-text">完成</span>
                      </div>
                      : <>
                        <div className="text-btn-delete" onClick={() => onDelete(idx, module)}>
                          删除
                        </div>
                        <div className="text-btn-line" />
                        <div
                          className="text-btn"
                          onClick={() => onEdit(idx, module)}
                        >
                          <span className="btn-text">编辑</span>
                        </div>
                      </>
                  }
                  </div>
                }
                  </div>
                  <div className="steps-container">
                    {module?.editStatus
                      ? <div>
                        <div className="add-step-btn" onClick={() => onAddStep(module.id)}>
                          <Icon type="m-tianjia_miaobian" className="add-step-btn-icon" />
                          <span>添加步骤</span>
                        </div>
                        <div className="sort-wrapper">
                          <DragList
                            className="sort-wrapper-list"
                            data={module.steps}
                            handleKey="drag-icon"
                            onStop={(newVal, oldVal) => onSort(newVal, oldVal, module.id)}
                            renderItem={(cur, index, { draggableKey }) => {
                              if (index !== module.steps.length - 1) {
                                return <Item
                                  key={cur.tempId}
                                  step={cur}
                                  index={index}
                                  draggableKey={index !== module.steps.length - 1 && draggableKey}
                                  onDeleteStep={() => onDeleteStep(module.id, cur.tempId)}
                                  stepChange={(val) => stepChange(val, module?.id, cur.tempId)}
                                />
                              }
                              return <ItemDisable
                                key={cur.tempId}
                                step={cur}
                                index={index}
                              />
                            }}
                          />
                        </div>
                      </div>
                      : <div>
                        {module?.steps?.length > 0 ? module?.steps.map((step, index) => {
                          return <div className="step-item" key={index}>
                            <span className="step-item-index">{index + 1}</span>
                            <span className="step-item-title">{step.stepName}</span>
                          </div>
                        }) : null}
                      </div>}
                  </div>
                </div>
              })}
            </div>
          </div>
        </div>
      }
  </div>
}

const ItemDisable = ({ step, index }) => {
  return <div className="step-item-disable">
    <div>
      <span className="step-item-index">{index + 1}</span>
      <span className="step-item-title">{step?.stepName}</span>
    </div>
    <span className="un-edit">不可移动</span>
  </div>
}

const Item = ({
  step,
  index,
  stepChange,
  onDeleteStep,
  draggableKey
}) => {
  return <div className={classNames('edit-item', draggableKey)} data-id={step.tempId}>
    <div className={classNames('edit-step-item', { editStatus: step.editStatus })}>
      <Icon className="drag-icon" type="m-tuodong" />
      <span className="step-item-index">{index + 1}</span>
      <span
        className="step-select"
      >
        <StepSelect
          value={step.stepName}
          onChange={(val) => stepChange(val)}
        />
      </span>
    </div>
    <Icon className="delete-icon" type="m-jianshao_miaobian" onClick={onDeleteStep} />
  </div>
}

/**
   * @description: 流程步骤编辑模式下拉框
   * @param {string} value 流程
   * @param {function} onChange 修改流程的方法
   * @return {*}
   */
const StepSelect = (props) => {
  const { value, onChange, onFocus, onBlur } = props
  const [inputVal, setInputVal] = useState('')
  const [focus, setFocus] = useState(false)
  const [isCustom, setIsCustom] = useState(false)
  const [visible, setVisible] = useState(false)
  const inputChange = (e) => {
    if (e?.target?.value?.trim()?.length > 4) {
      return message.warning('自定义步骤名称最多支持4个字')
    }
    setIsCustom(false)
    onChange?.(e.target.value)
  }

  const onKeyUp = (e) => {
    if (e.keyCode === 13) {
      inputChange(e)
      setFocus(false)
    }
  }

  const _onChange = (...arg) => {
    onChange?.(...arg)
    setVisible(false)
  }
  const _onBlur = () => {
    setFocus(false)
    onBlur?.()
  }
  const _onFocus = () => {
    setFocus(true)
    onFocus?.()
  }
  return (
    <Dropdown
      trigger={['click']}
      visible={visible}
      disabled={focus}
      onVisibleChange={vis => setVisible(vis)}
      overlay={<Menu
        value={value}
        onChange={_onChange}
        setIsCustom={(val) => {
          setIsCustom(val)
          setVisible(false)
        }}
      />}
      getPopupContainer={(triggerNode) => triggerNode.parentElement}
      className={styles['mn-step-select']}
    >
      <div
        className={styles['select-text-container']}
      >
        {isCustom
          ? <Input
              maxLength={4}
              value={inputVal}
              onChange={(e) => setInputVal(e.target.value)}
              onBlur={(e) => {
                inputChange(e)
                _onBlur?.()
              }}
              onFocus={() => {
                _onFocus()
              }}
              onKeyUp={(e) => onKeyUp(e)}
              wrapStyle={{ width: '100%', height: 32 }}
          />
          : <span className={classNames('text', { active: value })}>{!isCustom && (value || '选择步骤')}</span>}
        <Icon type="m-Vxing_xia" style={{ fontSize: 16, verticalAlign: 'text-bottom', opacity: '0.68' }} />
      </div>
    </Dropdown>
  )
}

const Menu = (props) => {
  const { value, onChange, setIsCustom } = props
  return <div className={styles['step-dropdown']}>
    {STEPS.map(item => {
      return <div
        className={classNames('step-dropdown-item', { active: value == item.value })}
        key={item.value}
        onClick={() => onChange?.(item.value)}
      >{item.label}</div>
    })}
    <div className={classNames('step-dropdown-item')} onClick={() => { setIsCustom(true) }}>自定义步骤</div>
  </div>
}
